import React, { FC, useEffect, useMemo, useState } from 'react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { EVENT_EVENTS } from 'Sp/Angular/Events/Client/Gallery';
import getTheme from 'ts/common/components/gallery/getTheme';

let theme: ReturnType<typeof extendTheme> | undefined;

const useTheme = (
    spEventBus: SpAngularJs.ISpEventBus,
    providedEventTheme?: SpApi.Client.IEventTheme
) => {
    const [eventTheme, setEventTheme] = useState<SpApi.Client.IEventTheme | undefined>(
        providedEventTheme
    );

    useEffect(() => {
        const off = spEventBus.on<SpApi.Client.IEvent>(EVENT_EVENTS.GOT, (eventData) => {
            setEventTheme(eventData.theme);
        });

        if (!providedEventTheme) {
            spEventBus.emit(EVENT_EVENTS.GET);
        }

        return off;
    }, [providedEventTheme, spEventBus]);

    theme = useMemo(() => {
        return theme ?? (eventTheme && extendTheme(getTheme(eventTheme)));
    }, [eventTheme]);

    return { eventTheme, theme };
};

export const withTheme = <P extends object>(
    Component: FC<P>,
    providedGalleryTheme?: SpApi.Client.IEventTheme
): React.FC<P & { spEventBus: SpAngularJs.ISpEventBus }> =>
    function WithTheme({ spEventBus, ...props }) {
        const { theme } = useTheme(spEventBus, providedGalleryTheme);

        return theme ? (
            <ChakraProvider cssVarsRoot="body" resetCSS={false} theme={theme}>
                <Component {...(props as P)} />
            </ChakraProvider>
        ) : null;
    };

export default useTheme;
